import { Box, Text } from "@chakra-ui/react";
import { DragEvent, useState } from "react";

interface DropZoneProps {
    text: string,
    isVisible: boolean,
    onDrop: (e: DragEvent<HTMLDivElement>) => void
}

export const DropZone = (props: DropZoneProps) => {
    const { text, isVisible, onDrop } = props;
    const [isActive, setIsActive] = useState(false);

    const handleDragOver = (e: DragEvent<HTMLDivElement>) => {
        e.preventDefault();
        setIsActive(true);
    };

    const handleDragLeave = () => {
        setIsActive(false);
    };

    const handleDrop = (e: DragEvent<HTMLDivElement>) => {
        e.preventDefault();
        setIsActive(false);
        onDrop(e);
    };

    return (!isVisible) ? null :
        (<Box
            h="50px"
            mb={3}
            border="2px dashed"
            borderColor={isActive ? "blue.400" : "gray.300"}
            bg={isActive ? "blue.50" : "transparent"}
            borderRadius="md"
            display="flex"
            alignItems="center"
            justifyContent="center"
            transition="all 0.2s"
            onDragOver={handleDragOver}
            onDragLeave={handleDragLeave}
            onDrop={handleDrop}
        >
            <Text fontSize="sm" color="gray.600">{text}</Text>
        </Box>
    );
};